import React, { FC } from 'react'
import classNames from 'classnames'
import CheckIcon from 'assets/icons/CheckIcon'

import styles from './SearchableCountryListItem.module.scss'

import { Country } from 'api/countries/getCountriesList'

interface Props {
  country: Country
  isSelected: boolean
  onCountrySelect: (country: Country) => void
}

export const SearchableCountryListItem: FC<Props> = ({
  country,
  isSelected,
  onCountrySelect
}) => {
  return (
    <div
      className={classNames(styles.Item)}
      key={country.alpha2}
      onClick={() => onCountrySelect(country)}
      tabIndex={0}
      onKeyDown={() => onCountrySelect(country)}
    >
      <div className={styles.CountryContent}>
        <img className={styles.Flag} src={country.flagUrl} alt={country.name} />
        <div className={styles.Name}>{country.name}</div>
        <div className={styles.CountryCode}>{`+ ${country.countryCode}`}</div>
      </div>
      {isSelected && (
        <div className={styles.IsSelectedIcon}>
          <CheckIcon />
        </div>
      )}
    </div>
  )
}
